// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
import { DataCache } from '@shared/commons/DataCache';
import { Resources } from '@shared/localizations/Resources';
import { TerceraComboBox } from './TerceraComboBox';
export class TerceraAssetComboBox extends TerceraComboBox {
    constructor() {
        super();
    }
    oninit() {
        super.oninit();
        this.observe('allItemVisible', this.repopulateItems);
    }
    repopulateItems() {
        const items = [];
        const assets = DataCache.getAssetDict();
        for (const key in assets) {
            const asset = assets[key];
            items.push({ type: NewContextMenuItemType.Default, text: asset.Name, value: asset.Id });
        }
        items.sort(TerceraAssetComboBox.compareAssets);
        if (this.get('allItemVisible')) {
            items.splice(0, 0, {
                type: NewContextMenuItemType.Default,
                text: Resources.getResource('panel.TerceraSymbolLookupDropDownForm.All'),
                value: 'All'
            });
        }
        void this.set('items', items);
    }
    static compareAssets(a0, a1) {
        return a0.text.localeCompare(a1.text);
    }
}
TerceraComboBox.extendWith(TerceraAssetComboBox, {
    data: function () {
        return { allItemVisible: true };
    }
});
